import { modifier } from 'ember-modifier';

export default modifier(
  function scrollToAnchor(/* element , positional, named*/) {
    if (document.location.hash) {
      const element = document.querySelector(document.location.hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  }
);
